module.exports = __webpack_public_path__ + "img/icon-chart.66e66ceb.svg";